import { type Dtos, type SuretyAccountId } from "@inrev/common";
import { WipAnalysisPanel } from "@portal/components/features/wip-analysis/WipAnalysisPanel";
import { WipAnalysisPeriodSelectorProvider } from "@portal/components/features/wip-analysis/WipAnalysisPeriodSelectorProvider";
import { WipColumnSelectorProvider } from "@portal/components/features/wip-analysis/WipColumnSelectorProvider";
import { WipReviewPanel } from "@portal/components/features/wip-review/WipReviewPanel";
import { WorkspaceWrapper, type WorkspaceWrapperTab } from "@portal/components/patterns";
import { type FC, useState } from "react";

type WipWorkspaceTabId = "review" | "analysis";

const WIP_SHELL_TABS: WorkspaceWrapperTab<WipWorkspaceTabId>[] = [
	{ id: "review", label: "WIP Review" },
	{ id: "analysis", label: "WIP Analysis" },
];

export type WipWorkspaceProps = {
	accountId: SuretyAccountId;
	extractions: ReadonlyArray<Dtos.Wip.Extraction.Get.Response>;
	lineItems: ReadonlyArray<Dtos.Wip.LineItem.Get.Response>;
	projects: ReadonlyArray<Dtos.Wip.Project.Get.Response>;
	statements: ReadonlyArray<Dtos.Wip.Statement.Get.Response>;
};

export const WipWorkspace: FC<WipWorkspaceProps> = ({
	accountId,
	extractions,
	lineItems,
	projects,
	statements,
}) => {
	const [activeTabId, setActiveTabId] = useState<WipWorkspaceTabId>("review");

	return (
		<WipColumnSelectorProvider key={accountId}>
			<WipAnalysisPeriodSelectorProvider extractions={extractions} statements={statements}>
				<WorkspaceWrapper
					tabs={WIP_SHELL_TABS}
					activeTabId={activeTabId}
					onTabChange={setActiveTabId}
					tabListLabel="WIP sections"
					testId="wip-workspace"
					trackingId="account-admin-wip-workspace"
				>
					{activeTabId === "review" && <WipReviewPanel accountId={accountId} />}
					{activeTabId === "analysis" && (
						<WipAnalysisPanel
							extractions={extractions}
							lineItems={lineItems}
							projects={projects}
							statements={statements}
						/>
					)}
				</WorkspaceWrapper>
			</WipAnalysisPeriodSelectorProvider>
		</WipColumnSelectorProvider>
	);
};
